import ServiceLayout from "./ServiceLayout";
import { Typography, Box } from "@mui/material";
import { Helmet } from "react-helmet-async";

const IndoorPlantSetup = () => {
  return (
    <>
      <Helmet>
        <title>Indoor Plant Setup | KRM Landscape</title>
        <meta
          name="description"
          content="Professional indoor plant setup services by KRM Landscape to enhance interiors with natural greenery and air-purifying plants."
        />
        <meta
          name="keywords"
          content="Indoor Plant Setup, Indoor Plants, KRM Landscape, Interior Greenery, Air-Purifying Plants, Plant Installation, Home Plants, Office Plants"
        />
      </Helmet>

      <ServiceLayout title="Indoor Plant Setup">

        {/* Hero Image */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Box
            component="img"
            src="/images/indoorplants.jpg"
            alt="Indoor Plant Setup by KRM Landscape"
            sx={{
              width: { xs: "100%", md: "80%" },
              maxHeight: "400px",
              objectFit: "contain",
              borderRadius: "12px",
            }}
          />
        </Box>

        <Typography paragraph>
          At KRM Landscape, our Indoor Plant Setup service is designed to transform
          interiors into refreshing, elegant, and healthy living spaces. We bring
          nature indoors in a way that complements your architecture, lighting,
          and lifestyle creating environments that feel calm, vibrant, and alive.
        </Typography>

        <Typography paragraph>
          Our team carefully selects plants based on available natural light,
          ventilation, space layout, and maintenance preferences. From
          air-purifying plants and low-maintenance greens to decorative statement
          plants, we ensure every selection enhances both aesthetics and
          well-being.
        </Typography>

        <Typography paragraph>
          We provide complete end-to-end solutions, including plant selection,
          premium pot matching, placement planning, and aesthetic arrangement.
          Whether it’s a cozy home, a modern office, hotels, cafés, or commercial
          spaces, our indoor plant setups are thoughtfully curated to elevate the
          atmosphere without overwhelming the space.
        </Typography>

        <Typography paragraph>
          Beyond installation, we also guide you on plant care, watering schedules,
          and long-term maintenance, ensuring your indoor greenery remains healthy
          and beautiful. With KRM Landscape, indoor plants are not just decor,they
          become a living part of your space.
        </Typography>


      </ServiceLayout>
    </>
  );
};

export default IndoorPlantSetup;
